import { ReactNode } from 'react';
import {
  Grid2 as Grid,
  Box,
  BoxProps,
  Grid2Props as GridProps,
  Typography,
  Stack,
  StackProps,
  useTheme,
} from '@mui/material';

import { TextCardGridType } from '../utils/types';
import { responsivePagePadding } from '../utils/constants';

function TextCardGrid({
  gridContent,
  boxProps,
  gridProps,
  stackProps,
  children,
  id,
}: {
  gridContent: TextCardGridType;
  boxProps?: BoxProps;
  gridProps?: GridProps;
  stackProps?: StackProps;
  children?: ReactNode;
  id?: string;
}) {
  const theme = useTheme();
  const iconWidthHeight = { md: '30px', lg: '40px' };

  return (
    <Grid
      id={id}
      container
      spacing={4}
      justifyContent="center" // Center the cards
      alignItems="center"
      sx={{ width: '100%', margin: '0 auto', padding: responsivePagePadding }} // Ensure grid stays centered
    >
      {gridContent.map((item, index) => (
        <Grid
          {...gridProps}
          size={{ xs: 12, sm: 6, md: 4 }}
          key={index}
          sx={{
            ...gridProps?.sx,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Stack
            {...stackProps}
            sx={{
              backgroundColor: theme.palette.primary.light,
              padding: '10px 16px',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '15px',
              height: '200px', // Default height
              maxWidth: '300px', // Default maxWidth
              ...(stackProps?.sx || {}), // Override with any custom styles
            }}
          >
            {item.icon && (
              <Box
                sx={{
                  fontSize: { md: '20px', lg: '25px' },
                  background: theme.palette.common.white,
                  width: iconWidthHeight,
                  height: iconWidthHeight,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto',
                }}
                {...boxProps}
              >
                {item.icon}
              </Box>
            )}
            <Typography variant="body1" gutterBottom sx={{ color: theme.palette.common.white, marginBottom:2 }}>
              <strong>{item.title}</strong>
            </Typography>
            <Typography variant="body2" sx={{ color: theme.palette.common.white, padding: '0 5px' }}>
              {item.text}
            </Typography>
          </Stack>
        </Grid>
      ))}
      <Grid
        size={12}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
}

export default TextCardGrid;
